/* eslint-disable camelcase */
import CONSTANTS from "@/constants/billings.js";

/* global Stripe */
export default {
    name: "PaymentDialogHelper",
    data() {
        return {};
    },
    computed: {
        change_amount() {
            let creditsSum = this.data.selectedCreditsTotal
                ? this.data.selectedCreditsTotal
                : 0;

            let change =
                parseFloat(this.data.payment_amount) +
                parseFloat(creditsSum) -
                parseFloat(this.data.outstanding_amount);
            return !_.isNaN(change) ? change.toFixed(2) : 0;
        },
        payable() {
            return (
                parseFloat(this.data.outstanding_amount) == 0 &&
                parseFloat(this.data.credit_amount) >=
                    parseFloat(this.data.invoice_amount)
            );
        },
        is_extension_exist() {
            return (
                this.data.payment_type_object &&
                _.some(this.data.payment_type_object, { is_extension_exist: 1 })
            );
        },
        is_cash_selected() {
            return (
                _.get(this.data, "payment_type_object.category_id", false) ==
                    1 && parseFloat(this.change_amount) > 0
            );
        },
        is_cc_key_in() {
            return (
                _.get(this, "data.payment_type_object.name", "").indexOf(
                    "Keyed-in"
                ) >= 0
            );
        },
        is_gravity_key_in() {
            return this._checkPaymentName(
                _.get(this, "data.payment_type_object.name", ""),
                "keyed-in",
                "gravity"
            );
        },
        is_stripe_terminal() {
            return this._checkPaymentName(
                _.get(this, "data.payment_type_object.name", ""),
                "terminal",
                "stripe"
            );
        },
        is_stripe_keyed_in() {
            return this._checkPaymentName(
                _.get(this, "data.payment_type_object.name", ""),
                "keyed-in",
                "stripe"
            );
        },
        is_cc_card_in() {
            return (
                _.get(this, "data.payment_type_object.name", "").indexOf(
                    "On File"
                ) >= 0
            );
        },
        is_cc_terminal() {
            return (
                _.get(this, "data.payment_type_object.name", "").indexOf(
                    "Credit Card On Terminal"
                ) >= 0
            );
        },
        is_stripe_acss() {
            return (
                _.get(this, "data.payment_type_object.name", "").indexOf(
                    "ACSS Debit"
                ) >= 0
            );
        },
        is_no_terminal() {
            return (
                this.data.terminals && this.data.terminals[0] == "No Terminal"
            );
        },
        _cc_months() {
            moment.locale("en");
            return [
                { text: "Month (required)", value: "" },
                ...moment.months().map((month, index) => ({
                    text: month + " (" + _.padStart(index + 1, 2, "0") + ")",
                    value: _.padStart(index + 1, 2, "0")
                }))
            ];
        },
        _cc_years() {
            let current_year = moment().year();
            let years = [
                {
                    value: "",
                    text: "Year (required)"
                }
            ];

            for (var i = 0; i <= 10; i++) {
                years.push({
                    value: current_year,
                    text: current_year
                });
                current_year++;
            }

            return years;
        },
        has_invoice() {
            return _.get(this, "data.invoices.length") > 0;
        }
    },
    methods: {
        _selectPrimaryMethod(methods) {
            if (this.waitForPaymentMethod && methods && methods.length > 0) {
                this.data.payment_method_name = _.find(methods, {
                    isPrimary: 1
                });
                if (!this.data.payment_method_name) {
                    this.data.payment_method_name = methods[0];
                }
                this.waitForPaymentMethod = false;
            }
        },
        _selectChange() {
            if (this.change_amount > 0 && this.has_invoice) {
                if (this.is_cash_selected) {
                    this.data.change = "1";
                } else {
                    this.data.change = "2";
                }
            } else {
                this.data.change = "0";
            }
        },
        _selectPaymentTypeObject() {
            if (this.data.payment_type == "-1") {
                this.data.payment_type_object = null;
            } else if (this.data.payment_type == "CREDIT_ONLY") {
                this.data.payment_type_object = {
                    name: "Credit Only",
                    id: "CREDIT_ONLY"
                };
            } else {
                this.data.payment_type_object = _.find(this.data.paymentTypes, [
                    "id",
                    this.data.payment_type
                ]);
            }
        },
        async _updateCheckoutPaymentAmount() {
            this.$emit("loading");
            const response = await $.post(
                process.env.APPS +
                    "index.php/schedule/census/updateCheckoutPaymentAmount",
                {
                    fm_census_invoices: _.map(this.data.invoices, "id"),
                    fm_census_credits: _.map(this.data.credits, "id")
                }
            );
            if (response) {
                this.data.outstanding_amount =
                    response.form_data.outstanding_amount;
                this.data.currency_symbol = response.form_data.currency_symbol;
                this.data.invoice_amount = response.form_data.invoice_amount;
                this.data.credit_amount = response.form_data.credit_amount;
                this.data.invoice_with_line_item =
                    response.form_data.invoice_with_line_item;
            }
            this.$emit("loaded");
            return response;
        },
        _getPaymentTypes(data) {
            let self = this;
            let cconnect_iframe_config = "";

            if (data.module === "appointment") {
                cconnect_iframe_config = "&cconnect_iframe=295px";
            }

            this.$http
                .get(
                    process.env.PAYMENT_SERVICE +
                        "payment-type?cc_processor_enabled=" +
                        1 +
                        cconnect_iframe_config
                )
                .then(response => {
                    data.paymentTypes =
                        response.data.response.resources.payment_types;

                    data.credit_card_processor =
                        response.data.response.resources.processor;

                    data.cardconnect_iframe_url =
                        response.data.response.resources.cconnect_iframe_url;
                });
        },
        async _getTerminals(data) {
            let self = this;
            let terminals = [];
            await this.$http
                .get(
                    process.env.PAYMENT_SERVICE +
                        "terminals?manufacturer=CardConnect"
                )
                .then(response => {
                    data.terminals = response.data.response.resources;

                    if (data.terminals.length <= 0) {
                        data.terminals = ["No Terminal"];
                        data.terminal = 0;
                    } else {
                        data.terminal = _.keys(data.terminals)[0];
                    }

                    return data.terminals;
                });
        },
        // Create a ConnectionToken to the terminal
        // parameter: no more location_id,refer VET-357
        async _generateStripeConnectionToken(business_id) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI + "payment/stripe/terminal/token",
                    {
                        business_id: business_id
                    }
                )
                .then(response => {
                    if (response.data.response.message.code == 200) {
                        // console.log("secret", response.data.response.secret);
                        return response.data.response.secret;
                    } else {
                        this._message("Error while getting token.", "danger");
                    }
                });
        },
        // process stripe terminal payment
        async _processStripeTerminal(params, metadata, showMessage = true) {
            let discoveredReaders = null;
            let paymentIntentId = null;
            let paymentIntent = null;
            let error_msg = "";
            let response = null;
            let terminalReaderId = params.terminal;
            let businessId = params.businessId;

            if (!terminalReaderId) {
                return {
                    state: 1,
                    message: "No terminal location"
                };
            }

            // eslint-disable-next-line
            let terminal = StripeTerminal.create({
                onFetchConnectionToken: async () =>
                    this._generateStripeConnectionToken(businessId),
                onUnexpectedReaderDisconnect: async () =>
                    this._message("Disconnected from reader", "danger")
            });

            console.log("Initialize reader:", terminal);
            let simulated = !!params.isSimulator;
            let config = { simulated: simulated };

            if (simulated) {
                terminalReaderId = "SIMULATOR";
                terminal.setSimulatorConfiguration({
                    testCardNumber: params.testCardNumber
                });
            }

            try {
                let discoverResult = await terminal.discoverReaders(config);
                if (
                    discoverResult.error ||
                    discoverResult.discoveredReaders.length === 0
                ) {
                    console.log(
                        "Failed to discover: ",
                        discoverResult.error
                            ? discoverResult.error
                            : "No available readers."
                    );
                    return {
                        state: 1,
                        message: "Failed to discover readers."
                    };
                }
                discoveredReaders = discoverResult.discoveredReaders;
                console.log("Discover reader:", discoveredReaders);
            } catch (error) {
                console.log("Error in discovering readers:", error);
            }

            if (discoveredReaders && discoveredReaders.length > 0) {
                let selectedReader = discoveredReaders.find(
                    element => element.id == terminalReaderId
                );
                console.log("Select reader:", selectedReader);

                if (selectedReader) {
                    try {
                        let connectResult = await terminal.connectReader(
                            selectedReader
                        );
                        if (connectResult.error) {
                            console.log(
                                "Failed to connect: ",
                                connectResult.error
                            );
                            return {
                                state: 1,
                                message: connectResult.error.message
                            };
                        }
                        console.log(
                            "Connected to reader: ",
                            connectResult.reader.label
                        );
                    } catch (error) {
                        console.log("Error in connecting to reader:", error);
                    }
                } else {
                    console.log("Selected reader not available");
                    return {
                        state: 1,
                        message: "Selected reader not available"
                    };
                }

                console.log("Create payment Intent");
                paymentIntent = await this._createPaymentIntentStripe({
                    amount: Number(params.payment_amount),
                    client_id: params.client_id,
                    trans_type: "terminal",
                    business_id: this._setting.business_id,
                    metadata: metadata
                });
                paymentIntentId = paymentIntent.transaction_id;
                console.log("Payment intent created:", paymentIntent);

                if (paymentIntent) {
                    this.$root.$emit("stripe-reset-terminal", terminal);
                    console.log("Collect payment method.");

                    try {
                        let result = await terminal.collectPaymentMethod(
                            paymentIntent.client_secret
                        );
                        if (result.error) {
                            console.log(result.error);
                            return {
                                state: 1,
                                message: result.error.message
                            };
                        }
                        console.log(
                            "Payment method collected:",
                            result.paymentIntent
                        );
                        paymentIntent = result.paymentIntent;
                    } catch (error) {
                        console.log(
                            "Error in collecting payment method:",
                            error
                        );
                    }

                    console.log("Process payment.");
                    try {
                        let result = await terminal.processPayment(
                            paymentIntent
                        );
                        if (result.error) {
                            console.log(result.error);
                            error_msg = result.error.message;
                        } else if (result.paymentIntent) {
                            paymentIntentId = result.paymentIntent.id;
                            console.log(
                                "Payment processed:",
                                result.paymentIntent
                            );
                        }
                    } catch (error) {
                        console.log("Error in processing payment:", error);
                    }

                    // capture
                    console.log("Capture payment.");
                    try {
                        let result = await this._captureStripeTerminalPayment(
                            paymentIntentId
                        );
                        console.log("Payment captured:", result);
                        response = result.data.response;
                        if (response.message.code == 200) {
                            let status = response.message.payment_intent.status;

                            if (status === "requires_payment_method") {
                                return {
                                    state: 1,
                                    message: error_msg
                                };
                            }

                            if (showMessage) {
                                switch (status) {
                                    case "succeeded":
                                        this._message(
                                            "Payment succeeded!",
                                            "success"
                                        );
                                        break;
                                    case "processing":
                                        this._message(
                                            "Your payment is processing.",
                                            "warning"
                                        );
                                        break;
                                    default:
                                        this._message(
                                            "Something went wrong.",
                                            "danger"
                                        );
                                        break;
                                }
                            }
                        }
                    } catch (error) {
                        console.log("Error in capturing payment:", error);
                    }
                }
            }
            return response;
        },
        async _processServerDrivenStripeTerminal(
            params,
            metadata,
            showMessage = true
        ) {
            let self = this;
            let paymentIntentId = null;
            let paymentIntent = null;
            let error_msg = "";
            let response = null;
            console.log(params);
            let terminalReaderId = params.terminal; // use reader id instead location id
            let businessId = params.businessId;
            let valid = true;

            if (terminalReaderId) {
                console.log("Create payment Intent");
                paymentIntent = await self._createTerminalPaymentIntentStripe({
                    payment_amount: Number(params.payment_amount),
                    client_id: params.client_id,
                    trans_type: "terminal",
                    business_id: self._setting.business_id,
                    reader_id: terminalReaderId,
                    metadata: metadata
                });

                if (!paymentIntent) {
                    return false;
                }

                paymentIntentId = paymentIntent.transaction_id;
                console.log(
                    "Payment intent created and terminal initiated:",
                    paymentIntent
                );

                if (paymentIntent) {
                    let cancelData = {
                        business_id: self._setting.business_id,
                        reader_id: terminalReaderId,
                        transaction_id: paymentIntentId
                    };
                    self.$root.$emit("stripe-reset-terminal", cancelData);

                    console.log("Polling terminal status...");
                    let endPolling = false;
                    let keepCalling = true;
                    let delay = ms => new Promise(res => setTimeout(res, ms));

                    // To prevent 504 gateway timed out to barramundi, we set our own time out
                    // which is 2 minutes
                    setTimeout(function () {
                        keepCalling = false;
                    }, 120000);

                    while (!endPolling && keepCalling) {
                        await self
                            ._getStripeTerminalStatus({
                                business_id: self._setting.business_id,
                                reader_id: terminalReaderId,
                                transaction_id: paymentIntentId
                            })
                            .then(function (result) {
                                if (result.code == 200) {
                                    if (
                                        result.reader.action.status ==
                                        "succeeded"
                                    ) {
                                        console.log(
                                            "Payment collection succeeded"
                                        );
                                        valid = true;
                                        endPolling = true;
                                    } else if (
                                        result.reader.action.status == "failed"
                                    ) {
                                        console.log(
                                            "Payment collection failed"
                                        );
                                        valid = false;
                                        endPolling = true;
                                        response = {
                                            state: 1,
                                            message:
                                                result.reader.action
                                                    .failure_message
                                        };
                                        self._cancelTerminalPaymentIntentStripe(
                                            paymentIntentId,
                                            self._setting.business_id
                                        );
                                    } else {
                                        valid = false;
                                        endPolling = true;
                                        response = {
                                            state: 1,
                                            message:
                                                result.data.response.description
                                        };
                                        self._cancelTerminalPaymentIntentStripe(
                                            paymentIntentId,
                                            self._setting.business_id
                                        );
                                    }
                                } else if (result.code == 400) {
                                    console.log("Exception error");
                                    valid = false;
                                    endPolling = true;
                                    response = {
                                        state: 1,
                                        message: result.description
                                    };
                                    self._cancelTerminalPaymentIntentStripe(
                                        paymentIntentId,
                                        self._setting.business_id
                                    );
                                } else if (result.code == 201) {
                                    console.log(
                                        "Payment collection still in progress..."
                                    );
                                } else if (result.code == 204) {
                                    valid = false;
                                    endPolling = true;
                                    response = {
                                        state: 1,
                                        message: "Action canceled."
                                    };

                                    if (
                                        result.transaction_status != "canceled"
                                    ) {
                                        self._cancelTerminalPaymentIntentStripe(
                                            paymentIntentId,
                                            self._setting.business_id
                                        );
                                    }
                                } else {
                                    valid = false;
                                    endPolling = true;
                                    response = {
                                        state: 1,
                                        message: "Payment server timed out."
                                    };
                                    self._cancelTerminalPaymentIntentStripe(
                                        paymentIntentId,
                                        self._setting.business_id
                                    );
                                }
                            });
                        if (!endPolling) {
                            await delay(3000);
                        }
                    }

                    if (!keepCalling) {
                        valid = false;
                        response = {
                            state: 1,
                            message: "Payment server timed out."
                        };
                        this._cancelStripeTerminal(cancelData);
                        // self._cancelTerminalPaymentIntentStripe(
                        //     paymentIntentId,
                        //     self._setting.business_id
                        // );
                    }

                    if (valid) {
                        self.$root.$emit("capturing-stripe-terminal-payment");
                        // capture
                        await this._captureStripeTerminalPayment(
                            paymentIntentId
                        ).then(function (result) {
                            response = result.data.response;
                            if (response.message.code == 200) {
                                let status =
                                    response.message.payment_intent.status;

                                if (status === "requires_payment_method") {
                                    return {
                                        state: 1,
                                        message: error_msg
                                    };
                                }

                                if (showMessage) {
                                    switch (status) {
                                        case "succeeded":
                                            self._message(
                                                "Payment succeeded!",
                                                "success"
                                            );
                                            break;
                                        case "processing":
                                            self._message(
                                                "Your payment is processing.",
                                                "warning"
                                            );
                                            break;
                                        default:
                                            self._message(
                                                "Something went wrong.",
                                                "danger"
                                            );
                                            break;
                                    }
                                }
                            }
                        });
                    }
                }
                return response;
            } else {
                response = {
                    state: 1,
                    message: "No terminal location"
                };
                return response;
            }
        },
        /**
         * Gets called when the save stripe triggered. Must have
         * 'stripe_data' declared in 'data'.
         */
        _saveStripe(payment_data) {
            let key = _.get(this, "$root.cc_extension.STRIPE_PUBLIC_KEY");
            let self = this;
            if (!key) {
                this._message("Stripe not enabled", "danger");
                return;
            }

            Stripe.setPublishableKey(key);

            return new Promise((resolve, reject) => {
                Stripe.createToken(
                    {
                        number: payment_data.credit_card_card_number,
                        cvc: payment_data.credit_card_ccv,
                        exp_month: payment_data.credit_card_expiry_month,
                        exp_year: payment_data.credit_card_expiry_year
                    },
                    (status, response) => {
                        if (response.error) {
                            this._message(response.error.message, "danger");
                            reject(response);
                        } else {
                            resolve(response);
                        }
                    }
                );
            });
        },
        async _getStripeDetails(businessId) {
            let self = this;
            let data = await this.$http
                .get(process.env.BARRAMUNDI + "payment/stripe/account/detail", {
                    params: {
                        business_id: businessId
                    }
                })
                .then(response => {
                    let data = response.data.response.message.data;
                    if (response.data.response.message.code == 200) {
                        return data;
                    }
                });
            return data;
        },
        async _createPaymentIntentStripe(data) {
            let postData = {
                ...data,
                input_metadata: data.metadata
            };
            delete postData.metadata;

            return await this.$http
                .post(
                    process.env.BARRAMUNDI + "payment/stripe/secret",
                    postData
                )
                .then(response => {
                    return response.data.response;
                });
        },
        async _createTerminalPaymentIntentStripe(data) {
            let self = this;
            return await this.$http
                .post(process.env.BARRAMUNDI + "payment/stripe/secret", {
                    amount: data.payment_amount,
                    client_id: data.client_id,
                    trans_type: data.trans_type,
                    business_id: data.business_id,
                    reader_id: data.reader_id,
                    input_metadata: data.metadata
                })
                .then(response => {
                    let paymentIntent = response;
                    if (paymentIntent.data.response.message.code == 200) {
                        return paymentIntent.data.response;
                    } else {
                        let errorMessage =
                            paymentIntent.data.response.message &&
                            paymentIntent.data.response.message.description
                                ? paymentIntent.data.response.message
                                      .description
                                : "Stripe error";
                        self._message(errorMessage, "danger");
                        return false;
                    }
                });
        },
        async _getStripeTerminalStatus(data) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI +
                        "payment/stripe/terminal/status/once",
                    {
                        business_id: data.business_id,
                        reader_id: data.reader_id,
                        transaction_id: data.transaction_id
                    }
                )
                .then(response => {
                    let terminalStatus = response;

                    if (typeof terminalStatus !== "undefined") {
                        return terminalStatus.data.response;
                    } else {
                        // assume 504 gateway error, maybe the action taking too long
                        terminalStatus = {
                            data: {
                                response: {
                                    code: 504,
                                    description: "Payment server timed out."
                                }
                            }
                        };
                        return terminalStatus;
                    }
                });
        },
        async _cancelStripeTerminal(data) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI +
                        "payment/stripe/cancel/terminal/action",
                    {
                        business_id: data.business_id,
                        reader_id: data.reader_id,
                        transaction_id: data.transaction_id
                    }
                )
                .then(response => {
                    if (response.data.response.code == 200) {
                        return response.data.response;
                    }
                    return response;
                });
        },
        async _cancelTerminalPaymentIntentStripe(paymentIntentId, businessId) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI +
                        "payment/stripe/payment/cancel/" +
                        paymentIntentId,
                    {
                        business_id: businessId
                    }
                )
                .then(response => {
                    if (response.data.response.code == 200) {
                        return response.data.response;
                    }
                    return response;
                });
        },
        async _captureStripeTerminalPayment(paymentIntentId) {
            return await this.$http.get(
                process.env.BARRAMUNDI +
                    "payment/stripe/terminal/capture/" +
                    paymentIntentId
            );
        },
        async _confirmPaymentStripe(elements, Stripe) {
            let self = this;
            let stripe = Stripe;

            if (!Stripe) {
                this._message("Stripe not enabled", "danger");
                return;
            }

            if (Stripe?.stripe) {
                stripe = Stripe?.stripe;
            }

            let result = await stripe.confirmPayment({
                elements,
                redirect: "if_required"
            });

            return result;
        },
        async _confirmSetupStripe(elements, Stripe) {
            let self = this;
            let stripe = Stripe;

            if (!Stripe) {
                this._message("Stripe not enabled", "danger");
                return;
            }
            if (Stripe?.stripe) {
                stripe = Stripe?.stripe;
            }
            let result = await stripe.confirmSetup({
                elements,
                redirect: "if_required"
            });
            return result;
        },
        async _retrievePaymentIntentStripe(clientSecret, Stripe) {
            let paymentIntent = await Stripe.retrievePaymentIntent(
                clientSecret
            );
            return paymentIntent;
        },
        async _retrievePaymentMethodStripe(pm_id, Stripe) {
            let paymentMethod = await Stripe.paymentMethods.retrieve(pm_id);
            return paymentMethod;
        },
        async _receiptPrint(id) {
            // --- generating PDF
            const response = await $.get(
                process.env.APPS + "index.php/billing/payment/receipt_pdf",
                {
                    id: id
                }
            );

            if (response) {
                if (response.state == 0) {
                    this._redirect(response.uri, true);
                } else {
                    throw {
                        message: "Error while printing."
                    };
                }
            } else {
                throw {
                    message: "Error while printing."
                };
            }
        },
        async _processInteracRefund(data) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI + "payment/stripe/interac/refund",
                    data
                )
                .then(response => response.data.response);
        },
        async _getRefundByPaymentIntentId(data) {
            return await this.$http
                .post(
                    process.env.BARRAMUNDI + "payment/stripe/refund/payment",
                    data
                )
                .then(response => response.data.response);
        },
        async _proceedStripeInteracRefund(data) {
            let self = this;
            let response = null;

            if (data) {
                let cancelData = {
                    business_id: self._setting.business_id,
                    reader_id: data.reader_id
                };
                self.$root.$emit("stripe-reset-terminal", cancelData);

                let endPolling = false;
                let keepCalling = true;
                let valid = true;
                let delay = ms => new Promise(res => setTimeout(res, ms));

                setTimeout(function () {
                    keepCalling = false;
                }, 120000);

                return await self
                    ._processInteracRefund(data)
                    .then(async result => {
                        console.log("processInteracRefund", result);

                        if (result.message.code == 200) {
                            console.log("Polling terminal status...");
                            while (!endPolling && keepCalling) {
                                await self
                                    ._getStripeTerminalStatus({
                                        business_id: self._setting.business_id,
                                        reader_id: data.reader_id
                                    })
                                    .then(function (result) {
                                        if (result.code == 200) {
                                            if (
                                                result.reader.action.status ==
                                                "succeeded"
                                            ) {
                                                console.log("Refund succeeded");
                                                valid = true;
                                                endPolling = true;
                                            } else if (
                                                result.reader.action.status ==
                                                "failed"
                                            ) {
                                                console.log("Refund failed");
                                                valid = false;
                                                endPolling = true;
                                                response = {
                                                    state: 1,
                                                    message:
                                                        result.reader.action
                                                            .failure_message
                                                };
                                            } else {
                                                valid = false;
                                                endPolling = true;
                                                response = {
                                                    state: 1,
                                                    message:
                                                        result.data.response
                                                            .description
                                                };
                                            }
                                        } else if (result.code == 400) {
                                            console.log("Exception error");
                                            valid = false;
                                            endPolling = true;
                                            response = {
                                                state: 1,
                                                message: result.description
                                            };
                                        } else if (result.code == 201) {
                                            console.log(
                                                "Refund collection still in progress..."
                                            );
                                        } else if (result.code == 204) {
                                            valid = false;
                                            endPolling = true;
                                            response = {
                                                state: 1,
                                                message: "Action canceled."
                                            };
                                        } else {
                                            valid = false;
                                            endPolling = true;
                                            response = {
                                                state: 1,
                                                message:
                                                    "Refund server timed out."
                                            };
                                        }
                                    });
                                if (!endPolling) {
                                    await delay(3000);
                                }
                            }

                            if (!keepCalling) {
                                valid = false;
                                response = {
                                    state: 1,
                                    message: "Server timed out."
                                };
                                this._cancelStripeTerminal(cancelData);
                            }

                            if (valid) {
                                await self
                                    ._getRefundByPaymentIntentId(data)
                                    .then(result => {
                                        console.log(
                                            "getRefundByPaymentIntentId",
                                            result
                                        );
                                        if (result.code == 200) {
                                            response = {
                                                state: 0,
                                                refund: result.refund
                                            };
                                        }
                                    });
                            }
                        } else {
                            response = {
                                state: 1,
                                message: result.message.description
                            };
                        }

                        return response;
                    });
            }
        },
        /**
         * Checks whether a string contains both of the provided words, irrespective of their case.
         *
         * @param {string} originalStr - The string to check.
         * @param {string} word1 - The first word to search for in the original string.
         * @param {string} word2 - The second word to search for in the original string.
         * @returns {boolean} True if the original string contains both words (case insensitive), false otherwise.
         *
         * @example
         * // returns true
         * this._checkPaymentName("Credit Card On Terminal (Stripe)", "terminal", "stripe");
         *
         * @example
         * // returns false
         * this._checkPaymentName("Credit Card On Terminal (Stripe)", "terminal", "gravity");
         */
        _checkPaymentName(originalStr, word1, word2) {
            const lowerCaseStr = originalStr.toLowerCase();
            const lowerCaseWord1 = word1.toLowerCase();
            const lowerCaseWord2 = word2.toLowerCase();

            if (
                lowerCaseStr.includes(lowerCaseWord1) &&
                lowerCaseStr.includes(lowerCaseWord2)
            ) {
                return true;
            } else {
                return false;
            }
        },
        _generateMetadata(data, isAppointment = false) {
            let appointmentId = null;
            let actorId = null;
            let invoices = [];
            let checkoutDatetime = null;
            let credits = [];
            let documents = [];
            let rabies_docs = [];
            let vaccine_docs = [];
            let reminder_docs = [];
            let soap_docs = [];
            let wellness_docs = [];
            let letter_docs = [];

            if (isAppointment) {
                appointmentId = data?.id ?? null;
                actorId = data?.staff_id ?? null;
                invoices = data?.invoices ?? [];
                let mmt = data?.checkout_time ?? null;
                if (mmt) {
                    checkoutDatetime = mmt.unix();
                }
                credits = data?.credits ?? [];
                documents = data?.documents ?? [];
            } else {
                actorId = data?.staff?.id ?? null;
                let selectedInvoices = data?.invoices ?? [];
                invoices = selectedInvoices.map(obj => obj.id);
                let creditArray = data?.credits ?? [];
                credits = creditArray.map(obj => obj.id);

                let documentArray = data?.documents ?? [];
                documents = documentArray.map(obj => obj.id);

                let documentTypes = {
                    [CONSTANTS.DOCUMENT_TYPE.RABIES]: rabies_docs,
                    [CONSTANTS.DOCUMENT_TYPE.VACCINE]: vaccine_docs,
                    [CONSTANTS.DOCUMENT_TYPE.REMINDER]: reminder_docs,
                    [CONSTANTS.DOCUMENT_TYPE.SOAP]: soap_docs,
                    [CONSTANTS.DOCUMENT_TYPE.WELLNESS_PLAN]: wellness_docs,
                    [CONSTANTS.DOCUMENT_TYPE.LETTER]: letter_docs
                };

                for (let item of documentArray) {
                    let arr = documentTypes[item.id];

                    if (!arr) {
                        continue;
                    }

                    if (typeof item.docs === "string") {
                        arr.push(item.docs);
                    } else if (Array.isArray(item.docs)) {
                        arr = [...item.docs];
                    }
                }
            }

            let userId = null;
            if (data.staff && data.staff.id) {
                userId = data.staff.id;
            } else if (data.userId) {
                userId = data.userId;
            }

            return {
                business_id: data.business_id
                    ? data.business_id
                    : this._setting.business_id,
                payment_date: moment.tz(this._timeZone).unix(),
                type: data?.payment_type ?? null,
                client_id: data?.client_id ?? null,
                patient_id: data?.patient_id ?? null,
                invoices: invoices,
                amount: Number(data?.payment_amount ?? 0),
                change: Number(data?.change ?? 0),
                deposit_to_fund: Number(data?.deposit_to_fund ?? 0),
                pay_from_fund: Number(data?.pay_from_fund ?? 0),
                change_to_fund: Number(data?.change_to_fund ?? 0),
                fund_id: data?.fund_id ?? null,
                unique_id: data.uniqueId || data.unique_id || null,
                client_profile: true,
                documents: documents,
                export_type: data?.export_type ?? null,
                export_message: data?.export_message ?? null,
                rabies_docs: rabies_docs,
                vaccine_docs: vaccine_docs,
                reminder_docs: reminder_docs,
                soap_docs: soap_docs,
                wellness_docs: wellness_docs,
                letter_docs: letter_docs,
                is_census: isAppointment ? true : false,
                record_id: null,
                rabies_tag: data?.tag ?? null,
                appointment_id: appointmentId,
                status_id: data?.status ?? null,
                note: data?.notes ?? null,
                skip_appointment: isAppointment ? false : true,
                checkout_datetime: checkoutDatetime,
                actor_id: actorId,
                user_id: userId,
                credits: credits,
                skip_payment: data.skip_payment ?? false,
                isBnpl:
                    data.defaultPaymentMethod == "pay-over-time" ? true : false,
                paynow_invoice_id: data.paynow_invoice_id ?? null,
                payment_type_id: data.bnplPaymentType?.id ?? null,
                payment_type: data.bnplPaymentType?.name ?? null
            };
        },
        _socketPostPayment({ params, uniqueId, onSuccess, onPrint, onError }) {
            if (params.businessId !== this.$root.setting.business_id) {
                return;
            }
            if (params.userId !== this.$root.currentActor.id) {
                return;
            }
            if (params.uniqueId !== uniqueId) {
                return;
            }

            if (params.action === "payment:open:document") {
                if (onPrint) {
                    onPrint();
                } else if (params.s3_uri) {
                    window.open(params.s3_uri, "_blank"); // open pdf
                }
            } else if (params.action === "payment:refresh:success") {
                if (onSuccess) {
                    onSuccess();
                } else {
                    console.log("Unhandled success operation");
                }
            } else if (params.action === "payment:refresh:fail") {
                if (onError) {
                    onError(params.message);
                } else {
                    this._message(params.message, "warning");
                }
            }
        },
        showPaymentProcessingMessage() {
            this._message(
                "Please do not refresh your browser or exit this page while your payment is being processed.",
                "info",
                -1, // prevent auto close
                null,
                { isPaymentProcessing: true },
                "Payment Processing"
            );
        },
        closePaymentProcessingMessage() {
            if (window.paymentProcessingBanner) {
                window.toast.dismiss(window.paymentProcessingBanner);
                window.paymentProcessingBanner = null;
            }
        }
    }
};
